import _Span from './Span';

export * from './type';

export const Span = _Span;

export default Span;
